<template>
	<el-dialog :visible.sync="is_visible" :width="'40%'" @close="hide">
		<template slot="title">
			<h3 class="mb-0 font-weight-600">Invinity Summary</h3>
		</template>
		<div class="table-simple-modal">
			<b-table-simple bordered width="100%">
				<b-tbody>
					<b-tr>
						<b-th width="30%">Credit Officer</b-th>
						<b-td width="70%" colspan="2">{{ _gHlp.getValue(proposal, 'psal_approved_ssa_by_detail.name', '-') }}</b-td>
					</b-tr>
					<b-tr>
						<b-th width="30%">Advisor</b-th>
						<b-td colspan="2">{{ _gHlp.getValue(proposal, 'customer_detail.ssa_name', '-') }}</b-td>
					</b-tr>
					<b-tr>
						<b-th width="30%">Client Name</b-th>
						<b-td colspan="2">{{ _gHlp.getValue(proposal, 'customer_detail.name', '-') }}</b-td>
					</b-tr>

					<b-tr>
						<b-th width="70%" colspan="2">Loan Amount</b-th>
						<b-td width="30%">RM {{ _gHlp.getValue(currentInvSummary, 'loan_amount', 0) | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr>
						<b-th colspan="2">Loan Tenure</b-th>
						<b-td width="30%">{{ _gHlp.getValue(currentInvSummary, 'loan_tenure', 1) + ' ' +
							_gHlp.getValue(currentInvSummary, 'loan_tenure_period','Years') }}</b-td>
					</b-tr>
					<b-tr>
						<b-th colspan="2">Interest Rate</b-th>
						<b-td width="30%">{{ _gHlp.getValue(currentInvSummary, 'interest_rate', 0) }} %</b-td>
					</b-tr>
					<b-tr>
						<b-th colspan="2">Installment</b-th>
						<b-td width="30%">RM {{ _gHlp.getValue(currentInvSummary, 'installment_amount', 0) | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr>
						<b-th colspan="2" @click="show_debt_items = !show_debt_items" class="cursor-pointer">
							<div class=" d-flex align-items-center justify-content-between border-0 w-100">
								<div>Debt Consolidation Items</div>
								<div>
									<b-icon :icon="show_debt_items ? 'chevron-down' : 'chevron-right'" class="cursor-pointer"></b-icon>
								</div>
							</div>
						</b-th>
						<b-td>RM {{ _gHlp.getValue(currentInvSummary, 'debt_console_amount', 0) | moneyFormatter }}</b-td>
					</b-tr>
					<template v-if="show_debt_items">
						<b-tr v-for="(item, index) in _gHlp.getValue(currentInvSummary, 'debt_console_items', [])" :key="index">
							<b-td  colspan="2" style="color:#7d7f81"><i>- {{ item.label }}</i></b-td>
							<b-td style="color:#7d7f81"><i>RM {{ item.value | moneyFormatter }}</i></b-td>
						</b-tr>

						<!-- <b-tr>
							<b-td colspan="2" @click="show_cf_items = !show_cf_items" class="cursor-pointer">
								<div class=" d-flex align-items-center justify-content-between border-0 w-100">
									<div><i><u>- Charges & Fees</u></i></div>
									<div>
										<b-icon :icon="show_cf_items ? 'chevron-down' : 'chevron-right'" class="cursor-pointer"></b-icon>
									</div>
								</div>
							</b-td>
							<b-td><i><u>RM {{ total_charges_fees | moneyFormatter }}</u></i></b-td>
						</b-tr>
						<template v-if="show_cf_items">
							<b-tr>
								<b-td  colspan="2" style="color:#7d7f81"><i>-- Stamp Duty</i></b-td>
								<b-td style="color:#7d7f81"><i>RM {{ _gHlp.getValue(currentInvSummary, 'stamp_duty', 0) | moneyFormatter }}</i></b-td>
							</b-tr>
							<b-tr>
								<b-td  colspan="2" style="color:#7d7f81"><i>-- Vetting and Facilitation</i></b-td>
								<b-td style="color:#7d7f81"><i>RM {{ _gHlp.getValue(currentInvSummary, 'vet_fac_amt', 0) | moneyFormatter }}</i></b-td>
							</b-tr>
							<b-tr>
								<b-td  colspan="2" style="color:#7d7f81"><i>-- Stakeholder Sum</i></b-td>
								<b-td style="color:#7d7f81"><i>RM {{ _gHlp.getValue(currentInvSummary, 'stakeholder_sum', 0) | moneyFormatter }}</i></b-td>
							</b-tr>
							<b-tr>
								<b-td  colspan="2" style="color:#7d7f81"><i>-- Legal Fees</i></b-td>
								<b-td style="color:#7d7f81"><i>RM {{ _gHlp.getValue(currentInvSummary, 'legal_fees', 0) | moneyFormatter }}</i></b-td>
							</b-tr>
						</template> -->
					</template>
					<!-- <b-tr>
						<b-th colspan="2">Advance Payment</b-th>
						<b-td>RM {{ _gHlp.getValue(currentInvSummary, 'adv_payment_amount', 0) | moneyFormatter }}</b-td>
					</b-tr> -->
					<b-tr>
						<b-th colspan="2" @click="show_repay_items = !show_repay_items" class="cursor-pointer">
							<div class=" d-flex align-items-center justify-content-between border-0 w-100">
								<div>Repayment Source</div>
								<div>
									<b-icon :icon="show_repay_items ? 'chevron-down' : 'chevron-right'" class="cursor-pointer"></b-icon>
								</div>
							</div>
						</b-th>
						<b-td></b-td>
					</b-tr>
					<template v-if="show_repay_items">
						<b-tr v-for="(item, index) in _gHlp.getValue(currentInvSummary, 'repayment_source_items', [])" :key="index">
							<b-td colspan="2" style="color:#7d7f81"><i>- {{ item.facility + (item.proposed_via ? ' - ' + item.proposed_via : '') }}</i></b-td>
							<b-td style="color:#7d7f81"><i>RM {{ item.process_amount | moneyFormatter }}</i></b-td>
						</b-tr>
					</template>
					<b-tr v-if="is_flexi_loan">
						<b-th colspan="2">Flexi Loan Amount</b-th>
						<b-td>RM {{ _gHlp.getValue(currentInvSummary, 'flexi_loan_amount', 0) | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr v-if="is_flexi_loan">
						<b-th colspan="2">Flexi Interest Rate</b-th>
						<b-td>{{ _gHlp.getValue(currentInvSummary, 'flexi_interest_rate', 0) }} %</b-td>
					</b-tr>
					<b-tr v-if="is_flexi_loan">
						<b-th colspan="2">Flexi Loan Tenure (Months)</b-th>
						<b-td>{{ _gHlp.getValue(currentInvSummary, 'flexi_loan_tenure', 0) }}</b-td>
					</b-tr>
					<b-tr>
						<b-th colspan="2">Monthly Installment</b-th>
						<b-td>RM {{ _gHlp.getValue(currentInvSummary, 'installment_amount', 0) | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr v-if="is_moratorium">
						<b-th colspan="2">Moratorium Installment</b-th>
						<b-td>RM {{ _gHlp.getValue(currentInvSummary, 'moratorium_installment', 0) | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr v-if="is_moratorium">
						<b-th colspan="2">Moratorium Tenure ({{ _gHlp.getValue(currentInvSummary, 'moratorium_tenure_period', 'Months') }})</b-th>
						<b-td>{{ _gHlp.getValue(currentInvSummary, 'moratorium_tenure', 0) }}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>
	</el-dialog>
</template>
<script>
import { Dialog } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'


export default {
	props: ['proposal'],
	components: {
		[Dialog.name]: Dialog,
	},
	data() {
		return {
			is_visible: false,
			show_debt_items: true,
			show_cf_items: true,
			show_repay_items: true,
		}
	},
	computed: {
		...mapState(useInvinityStore, ['currentInvSummary']),
		is_moratorium() {
			return (_gHlp.getValue(this.currentInvSummary, 'moratorium_eligible', 0) == 1)
		},
		is_flexi_loan() {
			return (_gHlp.getValue(this.currentInvSummary, 'flexi_loan_eligible', 0) == 1)
		},
		// total_charges_fees() {
		// 	return parseFloat(_gHlp.getValue(this.currentInvSummary, 'stamp_duty', 0)) + parseFloat(_gHlp.getValue(this.currentInvSummary, 'vet_fac_amt', 0)) + parseFloat(_gHlp.getValue(this.currentInvSummary, 'stakeholder_sum', 0)) + parseFloat(_gHlp.getValue(this.currentInvSummary, 'legal_fees', 0))
		// }
	},
	methods: {
		show() {
			this.is_visible = true
		},
		hide() {
			this.is_visible = false
		}
	}
}
</script>